import { Tag, Tooltip, Typography } from 'antd'
import { CIMSTagProps } from './types'

/**
 * renders a customized Ant Design tag
 *
 * the `word-break` and `white-space` have been overwritten for you
 *
 * @param props {@link CIMSTagProps}
 */
export const CIMSTag: React.FC<CIMSTagProps> = ({
  tooltip,
  children,
  strikethrough,
  style,
  ...tagProps
}) => {
  return (
    <Tooltip
      trigger={['hover', 'focus']}
      title={
        tooltip && strikethrough
          ? `${tooltip} (Inactive)`
          : tooltip ?? undefined
      }
    >
      <Tag
        style={{
          wordBreak: 'break-word',
          whiteSpace: 'normal',
          ...style,
        }}
        {...tagProps}
      >
        {strikethrough ? (
          <Typography.Text delete={strikethrough}>{children}</Typography.Text>
        ) : (
          children
        )}
      </Tag>
    </Tooltip>
  )
}
